module.exports = __webpack_public_path__ + "img/_54A2271_t.ff3491cb.jpg";